<template>
    <div class="f-official-base-info">
        <!-- 官方流程状态展示 -->
        <div class="f-official-base-info-process">
            <info-icon class="f-official-base-info-label"
                :info="OfficialBoardLabel.OfficialProcess"
                :isrequired="NotRequired">
            </info-icon>
            <span>{{officialinfo.process | matchOfficialProcess}}</span>
        </div>

        <!-- 分配技术支持人员 -->
        <div class="f-official-base-info-duty">
            <info-icon class="f-official-base-info-label"
                :info="OfficialBoardLabel.DutyStaff"
                :isrequired="NotRequired">
            </info-icon>

            <staff-assign></staff-assign>
        </div>

        <!-- icafe链接 -->
        <div v-if="officialinfo.icafeUrl"
            class="f-official-base-info-icafe-link">
            <info-icon class="f-official-base-info-label"
                :info="OfficialBoardLabel.IcafeLink"
                :isrequired="NotRequired">
            </info-icon>
            <a :href="officialinfo.icafeUrl"
                target="_blank">{{officialinfo.icafeUrl}}</a>
        </div>

        <!-- 身份失效提示 -->
        <div v-if="isLostOfficial" class="f-official-base-info-lost-tip">
            <span>{{lostOfficialUser}}</span>
            <span>{{showTips.officialOperationLost}}</span>
        </div>

        <!-- 审核被拒绝原因-->
        <div class="f-official-base-info-audit-desc"
            v-if="officialinfo.process === 'OP_AUDIT_REJECT'">
            <div class="f-official-base-info-audit-desc-info">
                <span>您提交的回复已被</span>
                <span>{{officialinfo.auditUserInfoLast.nickname}}</span>
                <span>于</span>
                <span>{{officialinfo.auditRejectTime}}</span>
                <span>拒绝审核</span>
            </div>
            <div class="f-official-base-info-audit-desc-reason">
                <span>原因：</span>
                <span v-html="officialinfo.auditDescription"
                    class="f-official-base-info-audit-desc-reason-detail">
                </span>
            </div>
        </div>

        <!-- 审核通过提示-->
        <div class="f-official-base-info-audit-desc"
            v-if="isClosed">
            <div class="f-official-base-info-audit-desc-info">
                <span>您提交的回复已由</span>
                <span>{{officialinfo.auditUserInfoLast.nickname}}</span>
                <span>于</span>
                <span>{{officialinfo.auditPassTime}}</span>
                <span>审核通过</span>
            </div>
        </div>
    </div>
</template>

<style lang="less">
    @import '../../../../assets/less/views/topic-content/official-process/base-info.less';
</style>

<script>
    import {mapState, mapGetters} from 'vuex';
    import InfoIcon from './InfoIcon.vue';
    import StaffAssign from './StaffAssign.vue';

    export default {
        props: {
            isExpand: Boolean
        },
        components: {
            'info-icon': InfoIcon,
            'staff-assign': StaffAssign
        },
        data() {
            return {
                NotRequired: false
            };
        },
        computed: {
            ...mapState({
                OfficialBoardLabel: state => state.topicContent.OfficialBoardLabel,
                officialinfo: state => state.topicContent.topicData.ext.qaOfficialInfo,
                lostOfficialUser: state => state.topicContent.lostOfficialUser,
                showTips: state => state.topicContent.showTips
            }),
            ...mapGetters([
                'isClosed',
                'isLostOfficial'
            ])
        }
    };
</script>

